import React, { useEffect, useState } from "react";
import Footer from "../../components/Footer/Footer";
import Sidebar from "../../components/Sidebar/Sidebar";
import { createMember, deleteMember, getMembers } from "../../api/careTeamApi";
import ViewCareTeams from "../../components/careTeam/ViewCareTeams";

export default function CareTeam() {
  const [sidebarExpanded, setSidebarExpanded] = useState(true);
  const [careTeam, setCareTeam] = useState([]);
  const [newMember, setNewMember] = useState({
    role: "",
    name: "",
    phone: "",
    fax: "",
    location: "",
    hours: "",
  });
  const user_id = localStorage.getItem("userId");

  useEffect(() => {
    fetchMembers();
  }, [])

  const fetchMembers = async () => {
    try {
      const userId = localStorage.getItem("userId");

      if (!userId) {
        return;
      }

      const data = await getMembers(userId);

      setCareTeam(data);
    } catch (error) {
      console.error('Failed to fetch members');
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewMember((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddMember = async () => {
    if (!newMember.role || !newMember.name) {
      alert("Please enter at least a name and role.");
      return;
    }

    try {
      const userId = localStorage.getItem("userId");

      const newMember2 = await createMember({
        user_id: userId,
        role: newMember.role,
        name: newMember.name,
        phone: newMember.phone,
        fax: newMember.fax,
        location: newMember.location,
        hours: newMember.hours
      })

      setCareTeam([...careTeam, newMember2])
    } catch (error) {
      console.error('Failed to save care team member', error);
    }

    setNewMember({
      role: "",
      name: "",
      phone: "",
      fax: "",
      location: "",
      hours: "",
    });
  };

  const handleDeleteMember = async (id) => {
          try {
              await deleteMember(id);
              setCareTeam(careTeam.filter(member => member.id !== id));
          } catch (error) {
              console.error("Failed to delete member:", error);
          }
      }

  return (
    <div className={`ml-0 flex flex-col min-h-screen transition-all duration-300 ${sidebarExpanded ? 'md:ml-56' : 'md:ml-16'}`}>
      <Sidebar expanded={sidebarExpanded} setExpanded={setSidebarExpanded} />

      <main className="flex-1 p-6 overflow-auto bg-gray-100 space-y-8">

        <ViewCareTeams careTeam={careTeam} onDelete={handleDeleteMember} fetchMembers={fetchMembers} user_id={user_id}/>

        {/* add new care team member */}
        <div className="max-w-xl p-6 bg-white rounded-lg shadow space-y-4 border border-gray-200">
          <h2 className="mb-4 text-2xl font-semibold text-[#04395b]">Add New Care Team Member</h2>
          <div className="grid grid-cols-1 gap-4">
            <input
              type="text"
              name="role"
              value={newMember.role}
              onChange={handleChange}
              placeholder="Role (e.g. Primary Care Physician)"
              className="w-full p-2 border border-gray-300 rounded"
            />
            <input
              type="text"
              name="name"
              value={newMember.name}
              onChange={handleChange}
              placeholder="Name"
              className="w-full p-2 border border-gray-300 rounded"
            />
            <input
              type="text"
              name="phone"
              value={newMember.phone}
              onChange={handleChange}
              placeholder="Phone #"
              className="w-full p-2 border border-gray-300 rounded"
            />
            <input
              type="text"
              name="fax"
              value={newMember.fax}
              onChange={handleChange}
              placeholder="Fax #"
              className="w-full p-2 border border-gray-300 rounded"
            />
            <input
              type="text"
              name="location"
              value={newMember.location}
              onChange={handleChange}
              placeholder="Location"
              className="w-full p-2 border border-gray-300 rounded"
            />
            <input
              type="text"
              name="hours"
              value={newMember.hours}
              onChange={handleChange}
              placeholder="Hours"
              className="w-full p-2 border border-gray-300 rounded"
            />
          </div>

          <button
            onClick={handleAddMember}
            className="w-full py-2 mt-2 text-white bg-blue-600 rounded hover:bg-blue-700 transition"
          >
            Add Member
          </button>
        </div>
      </main>

      <Footer />
    </div>

  );
}
